import React, { useState } from "react";

export default function SeccionCursos() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCursos, setModalCursos] = useState([]);
  const [modalTitulo, setModalTitulo] = useState("");

  const tematicas = [
    {
      titulo: "Prevención y Evaluación de Incendios",
      cursos: [
        "Prevención de Incendios: Enseña a identificar y mitigar riesgos de incendio en diferentes entornos.",
        "Análisis de Riesgos de Incendio: Enseña a identificar y evaluar riesgos de incendio en diferentes entornos.",
        "Carga de Fuego: Asesoramiento general de carga de fuego.",
      ],
    },
    {
      titulo: "Equipamiento y Técnicas",
      cursos: [
        "Clases de Fuego y uso de Extintores: Enseña a identificar los diferentes tipos de fuego y cómo utilizar extintores de manera efectiva.",
        "Uso de Equipos de Protección Personal: Capacita en el uso correcto de equipos de protección personal para la lucha contra incendios.",
        "Manejo de red Contra Incendio: Enseña el uso de mangas, despliegue y mantenimiento.",
        "Reglas Generales de Ataque: Uso del agua como recurso de extinción, caudal y combustibles involucrados.",
      ],
    },
    {
      titulo: "Organización y Respuesta",
      cursos: [
        "Formación de Brigada de Incendios: Capacita a personas para formar parte de una brigada, incluyendo roles y responsabilidades.",
        "Informes sobre Incendios: Desarrollo de informes generales sobre incendios.",
        "Introducción a la Investigación de Incendios: Preservación de la escena, recopilación de datos, evidencias físicas.",
      ],
    },
  ];

  const abrirModal = (titulo, cursos) => {
    setModalTitulo(titulo);
    setModalCursos(cursos);
    setModalOpen(true);
  };

  return (
    <div className="relative min-h-screen bg-white">
      {/* Fondo con la imagen del logo */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: "url('/images/logo.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      {/* Contenido principal */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <h2 className="text-4xl font-semibold text-gray-800 mb-10">Cursos de Capacitación</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {tematicas.map((tema, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 transition duration-300 hover:scale-105"
            >
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">{tema.titulo}</h3>
              <p className="text-lg text-gray-700 mb-4">
                Cursos enfocados en {tema.titulo.toLowerCase()}.
              </p>
              <button
                onClick={() => abrirModal(tema.titulo, tema.cursos)}
                className="bg-green-500 text-white px-6 py-2 rounded-lg text-lg font-semibold hover:bg-green-600 transition mt-4"
              >
                Cursos Ofrecidos
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">{modalTitulo}</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700 text-left">
              {modalCursos.map((curso, index) => (
                <li key={index}>{curso}</li>
              ))}
            </ul>
            <div className="mt-6 text-right">
              <button
                onClick={() => setModalOpen(false)}
                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
